import { createContext, useContext, useState, ReactNode } from 'react'

interface Alert {
    id: string
    title: string
    body: string
}

interface AlertContextType {
    alerts: Alert[]
    addAlert: (alert: Alert) => void
    removeAlert: (id: string) => void
}

const AlertContext = createContext<AlertContextType | null>(null)

export function AlertProvider({ children }: { children: ReactNode }) {
    const [alerts, setAlerts] = useState<Alert[]>([])

    const addAlert = (alert: Alert) => {
        setAlerts(prev => [...prev, alert])
    }

    const removeAlert = (id: string) => {
        setAlerts(prev => prev.filter(a => a.id !== id))
    }

    return (
        <AlertContext.Provider value={{ alerts, addAlert, removeAlert }}>
            {children}
        </AlertContext.Provider>
    )
}

export function useAlerts() {
    const context = useContext(AlertContext)
    if (!context) {
        throw new Error('useAlerts must be used within AlertProvider')
    }
    return context
}
